import SelectClassMenu from "../student/components/SelectClassMenu";
import ButtonImg from "../components/ButtonImg";
import PrintQrButton from "../../../assets/images/classes/print_qr_btn.svg"
import LoginQrCodeModal from "./components/LoginQrCodeModal";
import {useEffect, useState} from "react";
import PrintExImg from "../../../assets/images/classes/print_ex_img.svg"


const  QRCodePage = ( {mainClass, setMainClass, classes, setClasses, students, fetchUpdateStudents, setIsEditable}) => {

    const [showLoginQrModal, setShowLoginQrModal] = useState(false);

    useEffect(() => {
        if (showLoginQrModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [showLoginQrModal]);

    const openLoginQrModal = () => {
        setShowLoginQrModal(true);
    };

    return (
        <>
            <div className="mt-8 text-xl font-medium text-center text-zinc-600 max-md:max-w-full">
                <div className="text-center"><span
                    className="text-[#50555f] text-xl font-medium ">학생들의 </span><span
                    className="text-[#355bdf] text-xl font-semibold">[로그인QR]</span><span
                    className="text-[#50555f] text-xl font-medium ">을 출력하여 </span><span
                    className="text-[#355bdf] text-xl font-semibold ">1초만에</span><span
                    className="text-[#50555f] text-xl font-medium "> AI 아크수학에 로그인 하세요!</span></div>
            </div>
            <div className="bg-[#ffffff] w-[1044px] flex justify-between items-center px-[52px] py-[20px] mt-8 rounded-[20px] border-[0.5px] border-[#DADADA] border-solid shadow">
                <div className="flex flex-wrap justify-center items-center p-[8px] min-h-[44px]">
                    <div className="relative w-[498px] h-[44px] ">
                        <SelectClassMenu
                            classList={classes}
                            setClasses={setClasses}
                            mainClass={mainClass}
                            setMainClass={setMainClass}
                            setIsEditable={setIsEditable}
                            fetchUpdateStudents={fetchUpdateStudents}
                        />
                    </div>
                </div>
                <div className="flex justify-center items-center ">
                    <div className="flex flex-wrap justify-end items-center">
                        <div className="flex gap-4">
                            <ButtonImg
                                image={PrintQrButton}
                                label="로그인 QR 인쇄"
                                onClick={() => openLoginQrModal()}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-[14px]">
                <img
                    src={PrintExImg}
                    alt="print example"/>
            </div>

            <LoginQrCodeModal
                showLoginQrModal={showLoginQrModal}
                setShowLoginQrModal={setShowLoginQrModal}
                students={students}
                mainClass={mainClass}
            />
        </>

    )
}

export default QRCodePage;